import UserSignInComponent from "../../components/UserSignInComponent";
import { 
    IonCardContent, IonButton
  } from '@ionic/react';

import OtpHeader from "./components/otpHeader";
import OtpContent from "./components/otpContent";
import "../../styles/VerifyLoginComponent.css"
import { IonContent } from "@ionic/react";

function OtpVerification(){

    return (
        <>
         <IonContent className="Loginpage">
            <UserSignInComponent>
                <OtpHeader/>
                <OtpContent/>
            </UserSignInComponent>
            </IonContent>
        </>
    )
}

export default OtpVerification;